import icon from './icon.svg'
import animation from './animation'

export default {
    icon,
    animation,
}
